import { forwardRef } from 'react';

import { type ModalElement } from '@hivebrite/design-system/Dialog';

import { type ModalProps } from './types';
import V1 from './V1';
import V2 from './V2';

export default forwardRef<ModalElement, ModalProps & { isOpen?: boolean }>(
  ({ isOpen, ...props }, ref) =>
    typeof isOpen === 'boolean' ? (
      <V2 {...props} isOpen={isOpen} ref={ref} />
    ) : (
      <V1 {...props} />
    ),
);
